import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { API_BASE_URL } from '@/common/config/api'

const baseQuery = fetchBaseQuery({
    baseUrl: API_BASE_URL,
    prepareHeaders: async (headers, { getState }) => {
        const token = getState().auth?.token

        if (token) {
            headers.set('authorization', `Bearer ${token}`)
            headers.set('Authorization-Scheme', 'WebStoreB2C')
        }
        return headers
    },
})

export const quickPartsApi = createApi({
    reducerPath: 'quickPartsApi',
    baseQuery,
    tagTypes: ['QuickParts'],
    endpoints: (builder) => ({
        getQuickParts: builder.query({
            query: (params) => ({
                url: '/quickparts',
                params,
            }),
            providesTags: ['QuickParts'],
        }),

        getQuickPart: builder.query({
            query: ({ id, params }) => ({
                url: `/quickparts/${id}`,
                params,
            }),
            providesTags: ['QuickParts'],
        }),

        getQuickPartsDrawingDto: builder.query({
            query: ({ name, part }) => ({
                url: '/quickparts/drawing',
                method: 'POST',
                body: { part, name },
            }),
        }),

        getQuickPartsSvg: builder.query({
            query: (part) => ({
                url: '/quickparts/svg',
                method: 'POST',
                body: part,
                responseHandler: (response) => {
                    const svg = response.text()
                    return svg
                },
            }),
        }),
    }),
})

export const {
    useGetQuickPartQuery,
    useGetQuickPartsQuery,
    useGetQuickPartsSvgQuery,
    useLazyGetQuickPartsDrawingDtoQuery,
} = quickPartsApi
